<template>
  <div class="fans">
    <label class="fans-label" for>粉丝识别标识</label>
    <el-radio-group :disabled="disabled" v-model="choose" @change="changeCustomTag">
      <el-radio :label="false">无标识</el-radio>
      <el-radio :label="true">打标签/分组</el-radio>
    </el-radio-group>
    <div v-show="choose">
      <div class="fans-tags">
        <span class="tags" v-for="tag in chooseList" :key="tag.name">{{tag.name}}</span>
      </div>
      <div class="fans-choose" @click="showDialog = true" v-if="!disabled">
        <i class="el-icon-circle-plus-outline"></i> 选择标签/分组
      </div>
    </div>

    <el-dialog
      title="选择标签/分组"
      :visible.sync="showDialog"
      width="75%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="fans-letter">
        <span
          :class="['all', {
          'active': curLetter == 'ALL'
        }]"
          @click="changeLetter('ALL')"
        >全部</span>
        <span
          :class="['letter', {
          'active': item == curLetter
        }]"
          v-for="item in letters"
          :key="item"
          @click="changeLetter(item)"
        >{{item}}</span>
      </div>

      <div class="fans-list">
        <template v-for="(item, idx) in tagList">
          <div
            class="fans-item"
            :key="item.name"
            @click.stop="handlerClick(idx, item.checked)"
            v-if="curLetter== 'ALL' || curLetter == item.prifex"
          >
            <span
              class="fans-checkbox"
              :class="{'checked': item.checked, 'el-icon-check': item.checked}"
            ></span>
            <div class="fans-card el-checkbox__label">
              {{item.name}}
              <i class="follower">{{item.followers > 999 ? '999+' : item.followers}}</i>
            </div>
          </div>
        </template>
      </div>

      <div class="fans-btn-wrap">
        <el-button type="info" size="small" @click="handlerDialogCancel">取消</el-button>
        <el-button type="primary" size="small" @click="handlerDialogConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'FansLabel',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    id: {
      type: [Number, String],
    },
    customTag: {
      type: [Boolean, Number],
      default: false,
    },
    customTags: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      choose: false,
      tags: [],
      showDialog: false,
      curLetter: 'ALL',
      letters: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
      ],
      tagList: [],
      tmptaglist: [],
      chooseList: [],
      sourceData: [],
    };
  },

  methods: {
    changeCustomTag() {
      this.$emit('changeChoose', this.choose);
    },

    changeLetter(item) {
      this.curLetter = item;
    },

    async getAllTags() {
      let res = await this.$http.get(`/api/${this.id}/custom-tags`);
      this.tmptaglist = [];
      res.forEach(item => {
        this.tmptaglist.push(...item.customTags);
      });
      this.fmtTags();
    },
    fmtTags() {
      let allTags = this.tmptaglist;

      let ret = [];
      allTags.forEach(item => {
        ret.push(
          Object.assign(item, {
            checked: !!this.tags.includes(item.customTagId),
          }),
        );
        if (this.tags.includes(item.customTagId)) {
          this.chooseList.push(item);
        }
      });

      this.sourceData = [...ret];
      this.tagList = [...ret];
    },

    setTags() {
      let ret = [],
        customTags = this.customTags || [];
      if (customTags.length > 0) {
        customTags.forEach(item => {
          ret.push(item.customTagId);
        });
      }
      return ret;
    },

    handlerDialogCancel() {
      let chooseArr = this.chooseList.map(item => item.customTagId);
      let ret = [];
      this.tagList.forEach(item => {
        ret.push(
          Object.assign(item, {
            checked: !!chooseArr.includes(item.customTagId),
          }),
        );
      });
      this.tagList = [];
      this.tagList = ret;
      console.log(this.chooseList);
      console.log(chooseArr);
      this.$emit('tagsChange', this.chooseList);
      this.showDialog = false;
    },

    handlerClick(idx, checked) {
      let item = this.tagList[idx];
      item.checked = !checked;
      console.log(item);
      this.tagList[idx] = item;

      let ret = this.tagList;
      this.tagList = [];
      this.tagList = ret;
    },

    handlerDialogConfirm() {
      this.getChooseItem();
      this.showDialog = false;
    },
    getChooseItem() {
      let taglist = this.tagList,
        ret = [];
      this.chooseList = [];
      taglist.map(item => {
        if (item.checked) {
          ret.push({
            customTagId: item.customTagId,
          });
          this.chooseList.push(item);
        }
      });
      console.log(ret);
      this.$emit('tagsChange', ret);
    },
  },

  created() {
    this.choose = !!this.customTag;
    this.tags = this.setTags();
  },

  mounted() {
    this.getAllTags();
  },
};
</script>

<style lang="scss" scoped>
.fans {
  /deep/ .el-radio__input.is-disabled.is-checked .el-radio__inner {
    background-color: #173bcf;
    color: #173bcf;
  }
  /deep/ .el-radio__input.is-disabled + span.el-radio__label {
    color: #606266;
  }

  &-label {
    padding-right: 36px;
  }
  &-choose {
    padding: 10px 0 0 120px;
    font-size: 14px;
    color: #173bcf;
    cursor: pointer;

    i {
      font-weight: bold;
    }
  }
  &-tags {
    padding: 20px 0 0 120px;
    .tags {
      box-sizing: border-box;
      display: inline-block;
      padding: 0 10px;
      margin-right: 12px;
      margin-bottom: 10px;
      height: 22px;
      line-height: 23px;
      font-size: 12px;
      background: #fff;
      border: 1px solid rgba(144, 147, 153, 0.2);
      border-radius: 2px;
      color: #909399;
      white-space: nowrap;
      user-select: none;
    }
  }

  /deep/ .el-dialog__title {
    font-size: 20px;
    color: #000;
  }
  /deep/ .el-dialog__body {
    padding: 0 0 40px 0;
  }

  &-letter {
    display: flex;
    padding-right: 60px;
    height: 45px;
    line-height: 45px;
    background: #606266;
    color: #fff;

    span {
      text-align: center;
      cursor: pointer;
      &:hover {
        color: #17cfb8;
      }
      &.letter {
        flex: 1;
        &.active {
          background: #17cfb8;
        }
      }

      &.all {
        width: 80px;
        &.active {
          background: #17cfb8;
        }
      }
    }
  }

  &-list {
    padding: 20px 30px;
    min-height: 300px;
    overflow: hidden;
  }
  &-checkbox {
    display: inline-block;
    width: 12px;
    height: 12px;
    border: 1px solid #dcdfe6;

    &.checked {
      background-color: #0091ff;
      border-color: #0091ff;
      color: #fff;
      font-size: 12px;
    }
  }
  &-item {
    float: left;
    margin: 10px 30px 20px 0;
    height: 36px;
    line-height: 36px;

    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #0091ff;
      border-color: #0091ff;
    }

    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #5e6166;
    }

    /deep/ .el-checkbox__label {
      margin-left: 10px;
      width: 154px;
      height: 36px;
      color: #5e6166;
      font-weight: normal;
      line-height: 34px;
      border: 1px solid #dcdfe6;
    }

    .follower {
      float: right;
      margin-right: 18px;
      font-style: normal;
      font-size: 14px;
      color: #0091ff;
    }
  }

  &-btn-wrap {
    text-align: center;
  }
}
</style>
